module.exports = __webpack_public_path__ + "img/click.961bfa11.gif";